module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-36-0797b48a144676cfe94920738742877b.svg";